import { TranslationObject } from '@ngx-translate/core';
import { AspectDimensions } from '@lib.core/entities/indicator/indicator';

export class KPI {
  title: TranslationObject;
  description: TranslationObject;
  unit: string;
  value: number;
  dimensions: AspectDimensions;
  performance1Y?: number;
  performance5Y?: number;
  performance1M?: number;

  constructor(
    title: TranslationObject,
    description: TranslationObject,
    unit: string,
    value: number,
    dimensions: AspectDimensions,
    performance1Y?: number,
    performance5Y?: number,
    performance1M?: number
  ) {
    this.title = title;
    this.description = description;
    this.unit = unit;
    this.value = value;
    this.dimensions = dimensions;
    this.performance1Y = performance1Y;
    this.performance5Y = performance5Y;
    this.performance1M = performance1M;
  }

  hasPerformance(): boolean {
    return this.performance1Y !== undefined
      || this.performance5Y !== undefined
      || this.performance1M !== undefined;
  }
}